export const SUPPORTED_LANGUAGES = ["sr-Latn", "en", "de", "ru", "fr", "es", "pt", "he"];
export const DEFAULT_LANGUAGE = "sr-Latn";
export const LANGUAGE_LABELS = {
    "sr-Latn": { short: "ME", name: "Montenegrin", nativeName: "Crnogorski" },
    en: { short: "EN", name: "English", nativeName: "English" },
    de: { short: "DE", name: "German", nativeName: "Deutsch" },
    ru: { short: "RU", name: "Russian", nativeName: "Russian" },
    fr: { short: "FR", name: "French", nativeName: "Francais" },
    es: { short: "ES", name: "Spanish", nativeName: "Espanol" },
    pt: { short: "PT", name: "Portuguese", nativeName: "Portugues" },
    he: { short: "HE", name: "Hebrew", nativeName: "Ivrit" }
};
export function isSupportedLanguage(value) {
    return !!value && SUPPORTED_LANGUAGES.includes(value);
}
